import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
// import { faPinterestP } from '@fortawesome/free-brands-svg-icons/faPinterestP';
// import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
// import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';

// import { faMobileAlt } from "@fortawesome/free-solid-svg-icons/faMobileAlt";

import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
// import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';

import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/faQuestionCircle';
// import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
// import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
// import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
// import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
// import { faStream } from "@fortawesome/free-solid-svg-icons/faStream";
// import { faLongArrowAltUp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltUp";
// import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
// import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
// import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
// import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
// import { faBookmark } from '@fortawesome/free-solid-svg-icons/faBookmark';

// add the imported icons to the library
library.add(
  faFacebookF,
  // faInstagram,
  faTwitter,
  // faPinterestP,
  // faYoutube,
  faLinkedinIn,
  // faFacebookSquare,
  faEnvelope,
  faQuestionCircle
  // faGlobe
  // faPaperPlane,
  // faSearch,
  // faTimes,
  // faChevronRight,
  // faStream,
  // faLongArrowAltUp,
  // faChevronCircleRight,
  // faInfoCircle,
  // faCheckCircle,
  // faTimesCircle,
  // faFacebookSquare,
  //   faBookmark
);
export default function faInit() {
  // Tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
  dom.watch();
}
